export default {
      id: "icon-filters-usage",
      viewBox: "0 0 23 16.881",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-filters",
      toString: function () {
        return this.url;
      }
    }